export const checkIfStringDashPlus = (value: string) =>
  /^[+-]?[0-9-]*$/.test(value);
